import React from 'react'

const CurvedImg = ({ img, bgcolor }) => {
    return (

        <div className="r w-full h-full ">
            <img src={img} className={bgcolor == 'orange' ? 'border-4 rounded-xl w-full h-[230px] object-cover border-orange' : 'w-full rounded-xl h-[230px] object-fill '} alt="" />
        </div>
    )
}

export default CurvedImg
